import React from 'react';
import StepBillingProvider from './StepBillingProvider';
import StepTaxInfo from './StepTaxInfo';
import StepAddress from './StepAddress';
import StepServiceLocation from './StepServiceLocation';
import StepRenderingProviders from './StepRenderingProviders';
import StepEhrScope from './StepEhrScope';
import StepClearinghouse from './StepClearinghouse';
import StepPayment from './StepPayment';

// step key 直接采用后端 onboardingStep slug（PUT /step 与续填不需要额外映射）；
// 表单命名空间仍为短名（billing / tax / ...），由 billingReviewData 的 STEP_FIELDS 关联
export const BILLING_STEP_KEYS = [
    'billing-provider',
    'tax-info',
    'address',
    'service-location',
    'rendering-providers',
    'claim-scope',
    'era',
    'payment-method',
] as const;

export type BillingStepKey = (typeof BILLING_STEP_KEYS)[number];

// 向导、Review 页、BillingInfoModal 共用同一套 Step 组件（组件读共享 Form，不收 props）
export function renderBillingStep(key: BillingStepKey) {
    switch (key) {
        case 'billing-provider':
            return <StepBillingProvider />;
        case 'tax-info':
            return <StepTaxInfo />;
        case 'address':
            return <StepAddress />;
        case 'service-location':
            return <StepServiceLocation />;
        case 'rendering-providers':
            return <StepRenderingProviders />;
        case 'claim-scope':
            return <StepEhrScope />;
        case 'era':
            return <StepClearinghouse />;
        case 'payment-method':
            return <StepPayment />;
        default:
            return null;
    }
}
